import React from 'react';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

interface PlayerAvatarProps {
  image: string;
  name: string;
  rating: number;
  onClick: () => void;
  isBlocked?: boolean;
}

const PlayerAvatar: React.FC<PlayerAvatarProps> = ({
  image,
  name,
  rating,
  onClick,
  isBlocked = false
}) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="flex flex-col items-center gap-2">
      <button
        onClick={onClick}
        disabled={isBlocked}
        className="relative"
      >
        <div className={cn(
          "relative w-32 h-32 sm:w-36 sm:h-36 lg:w-40 lg:h-40 rounded-full",
          "transform hover:scale-105 active:scale-95 transition-all duration-300",
          "z-10 shadow-lg hover:shadow-xl group/avatar",
          "bg-gradient-to-br from-light-100 to-light-200",
          isBlocked && "opacity-70 cursor-not-allowed"
        )}>
          <img
            src={image}
            alt={name}
            className={cn(
              "w-full h-full rounded-full object-cover",
              "ring-4 sm:ring-6 transition-colors duration-300",
              "ring-light-300 group-hover/avatar:ring-gold-600"
            )}
          />
        </div>
      </button>
      
    <div
  className={cn(
    "flex items-center rounded-full px-3 py-1 backdrop-blur-sm",
    isDarkMode ? "bg-dark-300/80" : "bg-light-200/80"
  )}
>
  <Star className={cn("h-4 w-4 mr-1", isDarkMode ? "text-gold-400" : "text-gold-600")} />
  <span className={cn("font-medium", isDarkMode ? "text-white" : "text-black")}>
    {rating.toFixed(1)}
  </span>
</div>


    </div>
  );
};
export default PlayerAvatar;